import React from 'react';
import Footer from './Layout/Footer';

function PrivacyPage() {
  return (
    <div className="app privacy-app">
      <header className="header scrolled">
        <div className="container">
          <div className="header-content">
            <a href="/" className="logo">
              <img src="/images/logo_req.jpg" alt="よし鮨" className="logo-img" />
            </a>
            <nav className="nav" aria-label="メインナビ">
              <ul>
                <li>
                  <a href="/">トップへ</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>

      <main className="legal-main">
        <div className="container">
          <h1 className="section-title">プライバシーポリシー</h1>
          <p className="privacy-intro">
            よし鮨（以下「当店」）は、お客様の個人情報の保護を重要な責務と考え、以下のとおり取り扱います。
          </p>

          <section className="privacy-block" aria-labelledby="purpose-heading">
            <h3 id="purpose-heading">個人情報の利用目的</h3>
            <p>ご予約の確認、お問い合わせへの回答のみに使用します。</p>
          </section>

          <section className="privacy-block" aria-labelledby="retention-heading">
            <h3 id="retention-heading">個人情報の保存期間</h3>
            <p>
              ご予約時にお預かりしたお名前・電話番号・メールアドレス等は、来店予定日から2か月が経過したものについて、月に1回、削除します。
            </p>
          </section>

          <section className="privacy-block" aria-labelledby="third-party-heading">
            <h3 id="third-party-heading">第三者提供の禁止</h3>
            <p>法令に基づく場合を除き、同意なく第三者に提供しません。</p>
          </section>

          <section className="privacy-block" aria-labelledby="analytics-heading">
            <h3 id="analytics-heading">解析ツールの利用</h3>
            <p>
              Google Analytics 4（GA4）を使用してアクセス統計を取得しています。本サービスでは Cookie
              を使用する場合があります。
            </p>
          </section>

          <section className="privacy-block" aria-labelledby="security-heading">
            <h3 id="security-heading">安全管理措置</h3>
            <p>SSL（暗号化）通信を使用し、適切に管理します。</p>
          </section>

          <section className="privacy-block" aria-labelledby="contact-heading">
            <h3 id="contact-heading">個人情報の取扱いに関する窓口</h3>
            <address>
              よし鮨<br />
              〒071-8143 北海道旭川市春光台３条３丁目９−２５<br />
              電話：
              <a href="tel:0166533032" className="footer-link">
                0166-53-3032
              </a>
              （受付時間は営業日の11:00～20:00）
              <br />
              メール：
              <a href="mailto:yoshizushi33@gmail.com" className="footer-link">
                yoshizushi33@gmail.com
              </a>
            </address>
          </section>

          <p className="privacy-date">制定日：2026年3月6日</p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default PrivacyPage;
